import { NEXT_PUBLIC_DEEPLINK_BASE_URL } from '@env';

/** Params to attach to a session continuity link */
type LinkQueryParam =
  | '_dl' // a hint to the app on what to do with the link
  | 'opaque_token'; // can be exchanged for a token via the exchangeOneTimeLoginToken mutation

/** These are attached to the deeplink itself */
type DeepQueryParam =
  | 'apn'
  | 'isi'
  | 'ibi'
  | 'imv'
  | 'amv'
  // provider token for app store
  | 'pt'
  // media token for app store. normally 8
  | 'mt'
  // campaign token for app store. normally dashboard
  | 'ct';

/** Builds a link */
export class DeeplinkBuilder {
  private deepUrl: URL;
  private linkUrl: URL;
  /** @param link: The link the deeplink points to */
  constructor(link: string) {
    this.deepUrl = new URL(NEXT_PUBLIC_DEEPLINK_BASE_URL);
    this.linkUrl = new URL(link);
  }

  /** Sets a key-value pair to the query string, is the value is valid
   * @returns this ReferralDeeplinkBuilder instance
   */
  setLinkQueryParam(paramName: LinkQueryParam, paramValue?: string): DeeplinkBuilder {
    if (paramValue && paramValue !== undefined && paramValue !== null) {
      this.linkUrl.searchParams.set(paramName, paramValue);
    }

    return this;
  }

  /** Sets a key-value pair to the query string, is the value is valid
   * @returns this ReferralDeeplinkBuilder instance
   */
  setDeepQueryParam(paramName: DeepQueryParam, paramValue?: string): DeeplinkBuilder {
    if (paramValue && paramValue !== undefined && paramValue !== null) {
      this.deepUrl.searchParams.set(paramName, paramValue);
    }

    return this;
  }

  public build(): string {
    this.deepUrl.searchParams.set('link', this.linkUrl.toString());
    return this.deepUrl.toString();
  }
}
